import api from '@api';

const fetchAccountStatement = payload => {
  return api.get('traders/me/accountStatement', payload);
};

export default fetchAccountStatement;
